import {
  css
} from 'lit';

export const LinkStyle = css`
.lds-link {
  font-size: inherit;
  font-weight: var(--lds-typography-link-font-weight);
  color: var(--lds-color-link-foreground);
  text-decoration: var(--lds-typography-link-text-decoration);
  cursor: var(--lds-animation-link-cursor);
}

/* When used with button elements, reset default system button styling attributes */
button.lds-link,
input.lds-link[type="button"],
input.lds-link[type="submit"],
input.lds-link[type="reset"] {
  padding: 0;
  margin: 0;
  line-height: inherit;
  background: none;
  border: 0;
}

.lds-link:hover,
.lds-link.hover,
.lds-link:active,
.lds-link.active,
.lds-link:visited,
.lds-link.visited {
  color: var(--lds-color-link-foreground);
  text-decoration: var(--lds-typography-link-text-decoration);
}

.lds-link:focus,
.lds-link.focus {
  outline-color: var(--lds-color-link-outline-focus);
  outline-offset: var(--lds-border-link-focus-outline-offset);
  outline-style: var(--lds-border-link-focus-outline-style);
  outline-width: var(--lds-border-link-focus-outline-width);
}

/* Handle coloring the disabled state for all psuedo states, primarily for button elements */
.lds-link.disabled,
button.lds-link.disabled,
input.lds-link[type="button"].disabled,
input.lds-link[type="submit"].disabled,
input.lds-link[type="reset"].disabled,
.lds-link.disabled:hover, .lds-link.disabled.hover,
button.lds-link.disabled:hover, button.lds-link.disabled.hover,
input.lds-link[type="button"].disabled:hover, input.lds-link[type="button"].disabled.hover,
input.lds-link[type="submit"].disabled:hover, input.lds-link[type="submit"].disabled.hover,
input.lds-link[type="reset"].disabled:hover, input.lds-link[type="reset"].disabled.hover,
.lds-link.disabled:active, .lds-link.disabled.active,
button.lds-link.disabled:active, button.lds-link.disabled.active,
input.lds-link[type="button"].disabled:active, input.lds-link[type="button"].disabled.active,
input.lds-link[type="submit"].disabled:active, input.lds-link[type="submit"].disabled.active,
input.lds-link[type="reset"].disabled:active, input.lds-link[type="reset"].disabled.active,
.lds-link.disabled:visited, .lds-link.disabled.visited,
button.lds-link.disabled:visited, button.lds-link.disabled.visited,
input.lds-link[type="button"].disabled:visited, input.lds-link[type="button"].disabled.visited,
input.lds-link[type="submit"].disabled:visited, input.lds-link[type="submit"].disabled.visited,
input.lds-link[type="reset"].disabled:visited, input.lds-link[type="reset"].disabled.visited,
button.lds-link[disabled],
input.lds-link[type="button"][disabled],
input.lds-link[type="submit"][disabled],
input.lds-link[type="reset"][disabled],
button.lds-link[disabled]:hover, button.lds-link.hover[disabled],
input.lds-link[type="button"][disabled]:hover, input.lds-link.hover[type="button"][disabled],
input.lds-link[type="submit"][disabled]:hover, input.lds-link.hover[type="submit"][disabled],
input.lds-link[type="reset"][disabled]:hover, input.lds-link.hover[type="reset"][disabled],
button.lds-link[disabled]:active, button.lds-link.active[disabled],
input.lds-link[type="button"][disabled]:active, input.lds-link.active[type="button"][disabled],
input.lds-link[type="submit"][disabled]:active, input.lds-link.active[type="submit"][disabled],
input.lds-link[type="reset"][disabled]:active, input.lds-link.active[type="reset"][disabled],
button.lds-link[disabled]:visited, button.lds-link.hover[disabled],
input.lds-link[type="button"][disabled]:visited, input.lds-link.visited[type="button"][disabled],
input.lds-link[type="submit"][disabled]:visited, input.lds-link.visited[type="submit"][disabled],
input.lds-link[type="reset"][disabled]:visited, input.lds-link.visited[type="reset"][disabled] {
  color: var(--lds-color-link-foreground-disabled);
  cursor: var(--lds-animation-link-cursor-disabled);
  text-decoration: var(--lds-typography-link-text-decoration-disabled);
}
`;

export default LinkStyle;
